import axios, { type AxiosResponse } from 'axios';
import type { ApiResponse } from '../types/api';

export function unwrapApiResponse<T>(response: AxiosResponse<ApiResponse<T>>) {
  const payload = response.data;

  if (payload && typeof payload === 'object' && 'ok' in payload) {
    if (!payload.ok) {
      throw new Error(payload.error || 'A API retornou um erro.');
    }

    return payload.data;
  }

  return payload as T;
}

export function getApiErrorMessage(error: unknown, fallbackMessage: string) {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;

    if (data && typeof data === 'object') {
      if ('error' in data && typeof data.error === 'string' && data.error.trim()) {
        return data.error;
      }

      if ('message' in data && typeof data.message === 'string' && data.message.trim()) {
        return data.message;
      }
    }

    if (error.message) {
      return error.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallbackMessage;
}
